<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="shops.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            storeModule="shop"
            :options="['export', 'settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :shop="scope.row"/>
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="shops.per_page"
        layout="total, prev, pager, next"
        :total="shops.total"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'name',
          order: 'ascending',
        },
      };
    },
    computed: {
      shops() {
        return this.$store.getters['shop/shops'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['shop/tableConfig']));
      },
      loading() {
        return this.$store.getters['shop/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('shop/setCurrentPage', val);
        this.$store.dispatch('shop/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        this.$store.commit('shop/setSorting', { prop, order });
        this.$store.dispatch('shop/fetchAll');
      },
    },
    async mounted() {
      this.$store.commit('shop/setCurrentPage', this.currentPage);
      this.$store.commit('shop/setSorting', this.currentSort);
      await this.$store.dispatch('shop/fetchAll');
    },
  };
</script>

